import { Button } from '@ophelos/ui/components/button';
import { cn } from '@ophelos/ui/lib/utils';

interface SegmentedControlProps<T extends string> {
  options: ReadonlyArray<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  'aria-label'?: string;
}

export function SegmentedControl<T extends string>({ options, value, onChange, disabled, 'aria-label': ariaLabel }: SegmentedControlProps<T>) {
  return (
    <div role="radiogroup" aria-label={ariaLabel} className="flex w-full gap-1 rounded-lg bg-muted/75 p-1">
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <Button
            key={option.value}
            variant={`${selected ? 'outline' : 'ghost'}`}
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={cn(
              'flex-1 h-10 rounded-md border-border-heavy px-3 text-sm font-medium transition-colors cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
              selected ? '' : 'text-muted-foreground',
            )}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}
